import React, { useContext, useEffect } from 'react';

import { Grid, Typography } from '@mui/material';
import { MailOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import SideBar from '../../uiParts/SideBar';
import { gray100 } from '../../../constants/Colors';
import { sideBarWidth, spHeaderHeight } from '../../../constants/Location';
import { AuthContext } from '../../../contexts/auth';
import CustomHead from '../CustomHead';

const styles = {
  container: {
    '@media screen and (min-width:961px)': {
      ml: sideBarWidth,
      height: '100vh'
    },
    '@media screen and (max-width:960px)': {
      mt: spHeaderHeight
    },
    direction: 'column',
    justifyContent: 'center',
    height: `calc(100vh - ${spHeaderHeight})`,
    minHeight: '100vh'
  },
  body: {
    '@media screen and (max-width:600px)': {
      mt: '64px'
    },
    textAlign: 'center',
    alignItems: 'center',
    mt: '160px'
  },
  icon: {
    '@media screen and (max-width:600px)': {
      height: '64px'
    },
    height: '80px',
    width: '100%',
    color: gray100
  },
  title: {
    '@media screen and (max-width:600px)': {
      m: '34px auto 0'
    },
    fontWeight: 500,
    color: gray100,
    fontSize: '24px',
    mt: '34px',
    textAlign: 'center'
  },
  text: {
    fontSize: '16px',
    color: gray100,
    m: '24px 16px 0',
    textAlign: 'center',
    fontWeight: 400
  }
};

const EmailChangeSent: React.FC = () => {
  // ログインチェック
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(AuthContext);
  useEffect((): void => {
    if (!isLoggedIn) {
      navigate('/auth/login');
      return;
    }
  }, []);

  return (
    <Grid container>
      <CustomHead title="メールアドレス変更 メール送信 | CMCOS[コムコス]" />
      <SideBar />
      <Grid container sx={styles.container}>
        <Grid item sx={styles.body}>
          <MailOutline sx={styles.icon} />
          <Typography sx={styles.title}>
            新しいメールアドレスに
            <br />
            認証メールを送信しました
          </Typography>
          <Typography sx={styles.text}>
            メールに記載されているURLをクリックして、認証を完了してください。
            <br />
            メール送信時点から24時間以内にお手続きください。
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmailChangeSent;
